// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Expln_test = require("../../rescript-utils/main/Expln_test.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("./MM_wrk_editor.bs.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.bs.js");

function isStmtStatusRemove(diff) {
  switch (diff.TAG | 0) {
    case /* StmtStatus */7 :
        return diff.proofStatus === undefined;
    case /* StmtStatusUnset */8 :
        return true;
    default:
      return false;
  }
}

function isStmtStatusSet(diff) {
  if (diff.TAG === /* StmtStatus */7) {
    return diff.proofStatus !== undefined;
  } else {
    return false;
  }
}

function isStmtMove(diff) {
  if (diff.TAG === /* StmtMove */11) {
    return true;
  } else {
    return false;
  }
}

function allMoveAndStatusSet(diff) {
  return diff.every(function (d) {
              if (isStmtMove(d)) {
                return true;
              } else {
                return isStmtStatusSet(d);
              }
            });
}

function editorSnapshotMake(st) {
  return {
          descr: st.descr,
          varsText: st.varsText,
          disjText: st.disjText,
          stmts: st.stmts.map(function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        typ: stmt.typ,
                        isGoal: stmt.isGoal,
                        jstfText: stmt.jstfText,
                        cont: MM_wrk_editor.contToStr(stmt.cont),
                        proofStatus: stmt.proofStatus
                      };
              })
        };
}

function updateEditorStateFromSnapshot(st, sn) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = sn.stmts.map(function (stmt) {
        return {
                id: stmt.id,
                label: stmt.label,
                labelEditMode: false,
                typ: stmt.typ,
                typEditMode: false,
                isGoal: stmt.isGoal,
                cont: MM_wrk_editor.strToCont(stmt.cont, Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors), undefined),
                contEditMode: false,
                isDuplicated: false,
                jstfText: stmt.jstfText,
                jstfEditMode: false,
                stmtErr: undefined,
                expr: undefined,
                jstf: undefined,
                proofTreeDto: undefined,
                src: undefined,
                proof: undefined,
                proofStatus: stmt.proofStatus,
                unifErr: undefined,
                syntaxErr: undefined
              };
      });
  newrecord.disjText = sn.disjText;
  newrecord.varsText = sn.varsText;
  newrecord.descr = sn.descr;
  return newrecord;
}

function proofStatusEq(a, b) {
  if (a !== undefined) {
    if (b !== undefined) {
      return a === b;
    } else {
      return false;
    }
  } else {
    return b === undefined;
  }
}

function updateStmt(sn, stmtId, update) {
  return {
          descr: sn.descr,
          varsText: sn.varsText,
          disjText: sn.disjText,
          stmts: sn.stmts.map(function (stmt) {
                if (stmt.id === stmtId) {
                  return Curry._1(update, stmt);
                } else {
                  return stmt;
                }
              })
        };
}

function addStmt(sn, idx, stmt) {
  var newStmts = sn.stmts.slice();
  newStmts.splice(idx, 0, stmt);
  return {
          descr: sn.descr,
          varsText: sn.varsText,
          disjText: sn.disjText,
          stmts: newStmts
        };
}

function removeStmt(sn, stmtId) {
  return {
          descr: sn.descr,
          varsText: sn.varsText,
          disjText: sn.disjText,
          stmts: sn.stmts.filter(function (stmt) {
                return stmt.id !== stmtId;
              })
        };
}

function applyDiffSingle(sn, diff) {
  switch (diff.TAG | 0) {
    case /* Descr */0 :
        return {
                descr: diff._0,
                varsText: sn.varsText,
                disjText: sn.disjText,
                stmts: sn.stmts
              };
    case /* Vars */1 :
        return {
                descr: sn.descr,
                varsText: diff._0,
                disjText: sn.disjText,
                stmts: sn.stmts
              };
    case /* Disj */2 :
        return {
                descr: sn.descr,
                varsText: sn.varsText,
                disjText: diff._0,
                stmts: sn.stmts
              };
    case /* StmtLabel */3 :
        var label = diff.label;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case /* StmtTyp */4 :
        var isGoal = diff.isGoal;
        var typ = diff.typ;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: typ,
                              isGoal: isGoal,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case /* StmtJstf */5 :
        var jstfText = diff.jstfText;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case /* StmtCont */6 :
        var cont = diff.cont;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case /* StmtStatus */7 :
        var proofStatus = diff.proofStatus;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: proofStatus
                            };
                    }));
    case /* StmtStatusUnset */8 :
        var stmtIds = diff.stmtIds;
        return {
                descr: sn.descr,
                varsText: sn.varsText,
                disjText: sn.disjText,
                stmts: sn.stmts.map(function (stmt) {
                      if (stmtIds.includes(stmt.id)) {
                        return {
                                id: stmt.id,
                                label: stmt.label,
                                typ: stmt.typ,
                                isGoal: stmt.isGoal,
                                jstfText: stmt.jstfText,
                                cont: stmt.cont,
                                proofStatus: undefined
                              };
                      } else {
                        return stmt;
                      }
                    })
              };
    case /* StmtAdd */9 :
        return addStmt(sn, diff.idx, diff.stmt);
    case /* StmtRemove */10 :
        return removeStmt(sn, diff.stmtId);
    case /* StmtMove */11 :
        var stmtId = diff.stmtId;
        var idx = diff.idx;
        var stmt = sn.stmts.find(function (stmt) {
              return stmt.id === stmtId;
            });
        if (stmt === undefined) {
          return sn;
        }
        var sn$1 = removeStmt(sn, stmtId);
        return addStmt(sn$1, idx, stmt);
    
  }
}

function getStmtIdsFromStatusUnset(diffs) {
  return diffs.map(function (diff) {
              if (diff.TAG === /* StmtStatus */7) {
                if (diff.proofStatus !== undefined) {
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "getStmtIdsFromStatusUnset: unexpected type of diff."
                        },
                        Error: new Error()
                      };
                }
                return diff.stmtId;
              }
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "getStmtIdsFromStatusUnset: unexpected type of diff."
                    },
                    Error: new Error()
                  };
            });
}

function findDiff(a, b) {
  var diffs = [];
  var aIds = Belt_HashSetString.fromArray(a.stmts.map(function (stmt) {
            return stmt.id;
          }));
  var bIds = Belt_HashSetString.fromArray(b.stmts.map(function (stmt) {
            return stmt.id;
          }));
  a.stmts.forEach(function (stmtA) {
        if (!Belt_HashSetString.has(bIds, stmtA.id)) {
          diffs.push({
                TAG: /* StmtRemove */10,
                stmtId: stmtA.id
              });
          return ;
        }
        
      });
  b.stmts.forEach(function (stmtB, i) {
        if (!Belt_HashSetString.has(aIds, stmtB.id)) {
          diffs.push({
                TAG: /* StmtAdd */9,
                idx: i,
                stmt: stmtB
              });
          return ;
        }
        
      });
  var aMod = {
    contents: diffs.reduce(applyDiffSingle, a)
  };
  var aModLen = aMod.contents.stmts.length;
  var bLen = b.stmts.length;
  if (aModLen !== bLen) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "aModLen != bLen"
          },
          Error: new Error()
        };
  }
  for(var i = 0; i < bLen; ++i){
    var stmtA = Caml_array.get(aMod.contents.stmts, i);
    var stmtB = Caml_array.get(b.stmts, i);
    if (stmtA.id !== stmtB.id) {
      var move_0 = stmtB.id;
      var move = {
        TAG: /* StmtMove */11,
        stmtId: move_0,
        idx: i
      };
      diffs.push(move);
      aMod.contents = applyDiffSingle(aMod.contents, move);
    }
    
  }
  b.stmts.forEach(function (stmtB, i) {
        var stmtA = Caml_array.get(aMod.contents.stmts, i);
        if (stmtA.id !== stmtB.id) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "stmtA.id != stmtB.id"
                },
                Error: new Error()
              };
        }
        if (stmtA.label !== stmtB.label) {
          diffs.push({
                TAG: /* StmtLabel */3,
                stmtId: stmtA.id,
                label: stmtB.label
              });
        }
        if (stmtA.typ !== stmtB.typ || stmtA.isGoal !== stmtB.isGoal) {
          diffs.push({
                TAG: /* StmtTyp */4,
                stmtId: stmtA.id,
                typ: stmtB.typ,
                isGoal: stmtB.isGoal
              });
        }
        if (stmtA.jstfText !== stmtB.jstfText) {
          diffs.push({
                TAG: /* StmtJstf */5,
                stmtId: stmtA.id,
                jstfText: stmtB.jstfText
              });
        }
        if (stmtA.cont !== stmtB.cont) {
          diffs.push({
                TAG: /* StmtCont */6,
                stmtId: stmtA.id,
                cont: stmtB.cont
              });
        }
        if (!proofStatusEq(stmtA.proofStatus, stmtB.proofStatus)) {
          diffs.push({
                TAG: /* StmtStatus */7,
                stmtId: stmtA.id,
                proofStatus: stmtB.proofStatus
              });
          return ;
        }
        
      });
  if (a.descr !== b.descr) {
    diffs.push({
          TAG: /* Descr */0,
          _0: b.descr
        });
  }
  if (a.varsText !== b.varsText) {
    diffs.push({
          TAG: /* Vars */1,
          _0: b.varsText
        });
  }
  if (a.disjText !== b.disjText) {
    diffs.push({
          TAG: /* Disj */2,
          _0: b.disjText
        });
  }
  if (diffs.length > 1 && diffs.every(isStmtStatusRemove)) {
    return [{
              TAG: /* StmtStatusUnset */8,
              stmtIds: getStmtIdsFromStatusUnset(diffs)
            }];
  } else {
    return diffs;
  }
}

function editorHistMake(initState, maxLength) {
  return {
          head: editorSnapshotMake(initState),
          prev: [],
          maxLength: Math.max(0, Math.min(1000, maxLength))
        };
}

function prependDiffToFirstElem(diff, prev, maxLength) {
  if (diff.length === 0) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "diff->Js_array2.length == 0"
          },
          Error: new Error()
        };
  }
  if (prev.length === 0) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "prev->Js_array2.length == 0"
          },
          Error: new Error()
        };
  }
  return [diff.concat(Caml_array.get(prev, 0))].concat(prev.slice(1, maxLength));
}

function editorHistAddSnapshot(ht, st) {
  if (MM_wrk_editor.isEditMode(st)) {
    return ht;
  }
  var newHead = editorSnapshotMake(st);
  if (ht.maxLength === 0) {
    return {
            head: newHead,
            prev: ht.prev,
            maxLength: ht.maxLength
          };
  }
  var diff = findDiff(newHead, ht.head);
  if (diff.length === 0 || diff.every(isStmtStatusSet)) {
    return ht;
  } else if (diff.every(isStmtStatusRemove)) {
    if (ht.prev.length === 0) {
      return {
              head: newHead,
              prev: ht.prev,
              maxLength: ht.maxLength
            };
    } else {
      return {
              head: newHead,
              prev: prependDiffToFirstElem(diff, ht.prev, ht.maxLength),
              maxLength: ht.maxLength
            };
    }
  } else if (allMoveAndStatusSet(diff) && ht.prev.length > 0 && allMoveAndStatusSet(Caml_array.get(ht.prev, 0))) {
    return {
            head: newHead,
            prev: prependDiffToFirstElem(diff, ht.prev, ht.maxLength),
            maxLength: ht.maxLength
          };
  } else {
    return {
            head: newHead,
            prev: [diff].concat(ht.prev.slice(0, ht.maxLength - 1 | 0)),
            maxLength: ht.maxLength
          };
  }
}

function editorHistSetMaxLength(ht, maxLength) {
  if (maxLength === ht.maxLength) {
    return ht;
  } else {
    return {
            head: ht.head,
            prev: ht.prev.slice(0, maxLength),
            maxLength: maxLength
          };
  }
}

function editorHistIsEmpty(ht) {
  return ht.prev.length === 0;
}

function editorHistLength(ht) {
  return ht.prev.length;
}

function editorHistGetSnapshotPreview(ht, idx, st) {
  if (idx === -1) {
    return {
            TAG: /* Ok */0,
            _0: updateEditorStateFromSnapshot(st, ht.head)
          };
  }
  var histLen = ht.prev.length;
  if (histLen === 0 || histLen <= idx) {
    return {
            TAG: /* Error */1,
            _0: "histLen == 0 || histLen <= idx"
          };
  }
  var curSn = ht.head;
  for(var i = 0; i <= idx; ++i){
    curSn = Caml_array.get(ht.prev, i).reduce(applyDiffSingle, curSn);
  }
  return {
          TAG: /* Ok */0,
          _0: MM_wrk_editor.recalcWrkColors(updateEditorStateFromSnapshot(st, curSn))
        };
}

function restoreEditorStateFromSnapshot(st, ht, idx) {
  return Belt_Result.map(editorHistGetSnapshotPreview(ht, idx, st), (function (st) {
                var newrecord = Caml_obj.obj_dup(st);
                newrecord.stmts = st.stmts.map(function (stmt) {
                      var newrecord = Caml_obj.obj_dup(stmt);
                      newrecord.proofStatus = undefined;
                      return newrecord;
                    });
                return newrecord;
              }));
}

function proofStatusToStr(status) {
  switch (status) {
    case /* Ready */0 :
        return "r";
    case /* Waiting */1 :
        return "w";
    case /* NoJstf */2 :
        return "n";
    case /* JstfIsIncorrect */3 :
        return "i";
    
  }
}

function proofStatusFromStr(str) {
  switch (str) {
    case "i" :
        return /* JstfIsIncorrect */3;
    case "n" :
        return /* NoJstf */2;
    case "r" :
        return /* Ready */0;
    case "w" :
        return /* Waiting */1;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to proofStatus."
            },
            Error: new Error()
          };
  }
}

function stmtSnapshotToLocStor(stmt) {
  return {
          d: stmt.id,
          l: stmt.label,
          t: MM_wrk_editor.userStmtTypeToStr(stmt.typ),
          g: stmt.isGoal,
          j: stmt.jstfText,
          c: stmt.cont,
          p: Belt_Option.map(stmt.proofStatus, proofStatusToStr)
        };
}

function stmtSnapshotFromLocStor(stmt) {
  return {
          id: stmt.d,
          label: stmt.l,
          typ: MM_wrk_editor.userStmtTypeFromStr(stmt.t),
          isGoal: stmt.g,
          jstfText: stmt.j,
          cont: stmt.c,
          proofStatus: Belt_Option.map(stmt.p, proofStatusFromStr)
        };
}

function editorSnapshotToLocStor(sn) {
  return {
          d: sn.descr,
          v: sn.varsText,
          j: sn.disjText,
          s: sn.stmts.map(stmtSnapshotToLocStor)
        };
}

function editorSnapshotFromLocStor(sn) {
  return {
          descr: sn.d,
          varsText: sn.v,
          disjText: sn.j,
          stmts: sn.s.map(stmtSnapshotFromLocStor)
        };
}

function editorDiffToLocStor(diff) {
  switch (diff.TAG | 0) {
    case /* Descr */0 :
        return {
                t: "D",
                s: diff._0
              };
    case /* Vars */1 :
        return {
                t: "V",
                s: diff._0
              };
    case /* Disj */2 :
        return {
                t: "J",
                s: diff._0
              };
    case /* StmtLabel */3 :
        return {
                t: "SL",
                d: diff.stmtId,
                s: diff.label
              };
    case /* StmtTyp */4 :
        return {
                t: "ST",
                d: diff.stmtId,
                b: diff.isGoal,
                s: MM_wrk_editor.userStmtTypeToStr(diff.typ)
              };
    case /* StmtJstf */5 :
        return {
                t: "SJ",
                d: diff.stmtId,
                s: diff.jstfText
              };
    case /* StmtCont */6 :
        return {
                t: "SC",
                d: diff.stmtId,
                s: diff.cont
              };
    case /* StmtStatus */7 :
        return {
                t: "SS",
                d: diff.stmtId,
                s: Belt_Option.map(diff.proofStatus, proofStatusToStr)
              };
    case /* StmtStatusUnset */8 :
        return {
                t: "SU",
                a: diff.stmtIds
              };
    case /* StmtAdd */9 :
        return {
                t: "SA",
                i: diff.idx,
                m: stmtSnapshotToLocStor(diff.stmt)
              };
    case /* StmtRemove */10 :
        return {
                t: "SR",
                d: diff.stmtId
              };
    case /* StmtMove */11 :
        return {
                t: "SM",
                d: diff.stmtId,
                i: diff.idx
              };
    
  }
}

function optGetEdls(opt, typ, attrName) {
  if (opt !== undefined) {
    return Caml_option.valFromOption(opt);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "'" + attrName + "' is not set in an editorDiffLocStor for typ = '" + typ + "'."
        },
        Error: new Error()
      };
}

function edlsGetId(d) {
  return optGetEdls(d.d, d.t, "d");
}

function edlsGetIds(d) {
  return optGetEdls(d.a, d.t, "a");
}

function edlsGetBool(d) {
  return optGetEdls(d.b, d.t, "b");
}

function edlsGetInt(d) {
  return optGetEdls(d.i, d.t, "i");
}

function edlsGetStr(d) {
  return optGetEdls(d.s, d.t, "s");
}

function edlsGetStmt(d) {
  return optGetEdls(d.m, d.t, "m");
}

function editorDiffFromLocStor(diff) {
  var match = diff.t;
  switch (match) {
    case "D" :
        return {
                TAG: /* Descr */0,
                _0: edlsGetStr(diff)
              };
    case "J" :
        return {
                TAG: /* Disj */2,
                _0: edlsGetStr(diff)
              };
    case "SA" :
        return {
                TAG: /* StmtAdd */9,
                idx: edlsGetInt(diff),
                stmt: stmtSnapshotFromLocStor(edlsGetStmt(diff))
              };
    case "SC" :
        return {
                TAG: /* StmtCont */6,
                stmtId: edlsGetId(diff),
                cont: edlsGetStr(diff)
              };
    case "SJ" :
        return {
                TAG: /* StmtJstf */5,
                stmtId: edlsGetId(diff),
                jstfText: edlsGetStr(diff)
              };
    case "SL" :
        return {
                TAG: /* StmtLabel */3,
                stmtId: edlsGetId(diff),
                label: edlsGetStr(diff)
              };
    case "SM" :
        return {
                TAG: /* StmtMove */11,
                stmtId: edlsGetId(diff),
                idx: edlsGetInt(diff)
              };
    case "SR" :
        return {
                TAG: /* StmtRemove */10,
                stmtId: edlsGetId(diff)
              };
    case "SS" :
        return {
                TAG: /* StmtStatus */7,
                stmtId: edlsGetId(diff),
                proofStatus: Belt_Option.map(diff.s, proofStatusFromStr)
              };
    case "ST" :
        return {
                TAG: /* StmtTyp */4,
                stmtId: edlsGetId(diff),
                typ: MM_wrk_editor.userStmtTypeFromStr(edlsGetStr(diff)),
                isGoal: edlsGetBool(diff)
              };
    case "SU" :
        return {
                TAG: /* StmtStatusUnset */8,
                stmtIds: edlsGetIds(diff)
              };
    case "V" :
        return {
                TAG: /* Vars */1,
                _0: edlsGetStr(diff)
              };
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert editorDiffLocStor to editorDiff for diff.typ='" + diff.t + "'."
            },
            Error: new Error()
          };
  }
}

function editorHistoryToLocStor(ht) {
  return {
          head: editorSnapshotToLocStor(ht.head),
          prev: ht.prev.map(function (diff) {
                return diff.map(editorDiffToLocStor);
              }),
          maxLength: ht.maxLength
        };
}

function editorHistoryFromLocStor(ht) {
  return {
          head: editorSnapshotFromLocStor(ht.head),
          prev: ht.prev.map(function (diff) {
                return diff.map(editorDiffFromLocStor);
              }),
          maxLength: ht.maxLength
        };
}

function editorHistToString(ht) {
  return Expln_utils_common.stringify(editorHistoryToLocStor(ht));
}

function parseStmtSnapshotLocStor(d) {
  return {
          d: Expln_utils_jsonParse.str(d, "d", undefined, undefined, undefined),
          l: Expln_utils_jsonParse.str(d, "l", undefined, undefined, undefined),
          t: Expln_utils_jsonParse.str(d, "t", undefined, undefined, undefined),
          g: Expln_utils_jsonParse.bool(d, "g", undefined, undefined, undefined),
          j: Expln_utils_jsonParse.str(d, "j", undefined, undefined, undefined),
          c: Expln_utils_jsonParse.str(d, "c", undefined, undefined, undefined),
          p: Expln_utils_jsonParse.strOpt(d, "p", undefined, undefined, undefined)
        };
}

function editorHistFromString(jsonStr) {
  return Belt_Result.map(Expln_utils_jsonParse.parseJson(jsonStr, (function (__x) {
                    return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                  return {
                                          head: Expln_utils_jsonParse.obj(d, "head", (function (d) {
                                                  return {
                                                          d: Expln_utils_jsonParse.str(d, "d", undefined, undefined, undefined),
                                                          v: Expln_utils_jsonParse.str(d, "v", undefined, undefined, undefined),
                                                          j: Expln_utils_jsonParse.str(d, "j", undefined, undefined, undefined),
                                                          s: Expln_utils_jsonParse.arr(d, "s", parseStmtSnapshotLocStor, undefined, undefined, undefined)
                                                        };
                                                }), undefined, undefined, undefined),
                                          prev: Expln_utils_jsonParse.arr(d, "prev", (function (d) {
                                                  return Expln_utils_jsonParse.asArr(d, (function (d) {
                                                                return {
                                                                        t: Expln_utils_jsonParse.str(d, "t", undefined, undefined, undefined),
                                                                        d: Expln_utils_jsonParse.strOpt(d, "d", undefined, undefined, undefined),
                                                                        b: Expln_utils_jsonParse.boolOpt(d, "b", undefined, undefined, undefined),
                                                                        i: Expln_utils_jsonParse.intOpt(d, "i", undefined, undefined, undefined),
                                                                        s: Expln_utils_jsonParse.strOpt(d, "s", undefined, undefined, undefined),
                                                                        m: Expln_utils_jsonParse.objOpt(d, "m", parseStmtSnapshotLocStor, undefined, undefined, undefined),
                                                                        a: Expln_utils_jsonParse.arrOpt(d, "a", (function (__x) {
                                                                                return Expln_utils_jsonParse.asStr(__x, undefined, undefined, undefined);
                                                                              }), undefined, undefined, undefined)
                                                                      };
                                                              }), undefined, undefined, undefined);
                                                }), undefined, undefined, undefined),
                                          maxLength: Expln_utils_jsonParse.$$int(d, "maxLength", undefined, undefined, undefined)
                                        };
                                }), undefined, undefined, undefined);
                  }), undefined, undefined, undefined), editorHistoryFromLocStor);
}

function stmtSnapshotToStringExtended(stmt) {
  var match = stmt.typ;
  var typStr = match ? (
      stmt.isGoal ? "G" : "P"
    ) : "H";
  var match$1 = stmt.proofStatus;
  var statusStr;
  if (match$1 !== undefined) {
    switch (match$1) {
      case /* Ready */0 :
          statusStr = "\u2713";
          break;
      case /* Waiting */1 :
          statusStr = "\u223F";
          break;
      case /* NoJstf */2 :
          statusStr = "?";
          break;
      case /* JstfIsIncorrect */3 :
          statusStr = "\u2717";
          break;
      
    }
  } else {
    statusStr = "";
  }
  return "" + stmt.id + ": " + statusStr + " " + stmt.label + " " + typStr + " [" + stmt.jstfText + "] " + stmt.cont + "";
}

function editorSnapshotToStringExtended(sn) {
  var res = [];
  res.push("Description");
  res.push(sn.descr);
  if (sn.descr.length > 0) {
    res.push("");
  }
  res.push("Variables");
  res.push(sn.varsText);
  if (sn.varsText.length > 0) {
    res.push("");
  }
  res.push("Disjoints");
  res.push(sn.disjText);
  if (sn.disjText.length > 0) {
    res.push("");
  }
  sn.stmts.forEach(function (stmt) {
        res.push(stmtSnapshotToStringExtended(stmt));
      });
  return res.join("\n");
}

function diffToStringExtendedSingle(diff) {
  switch (diff.TAG | 0) {
    case /* Descr */0 :
        return "Descr(" + diff._0 + ")";
    case /* Vars */1 :
        return "Vars(" + diff._0.replace(/[\n\r]+/g, " ; ") + ")";
    case /* Disj */2 :
        return "Disj(" + diff._0.replace(/[\n\r]+/g, " ; ") + ")";
    case /* StmtLabel */3 :
        return "StmtLabel({stmtId=" + diff.stmtId + ", label=" + diff.label + "})";
    case /* StmtTyp */4 :
        return "StmtTyp({stmtId=" + diff.stmtId + ", typ=" + MM_wrk_editor.userStmtTypeToStr(diff.typ) + ", isGoal=" + Expln_utils_common.stringify(diff.isGoal) + "})";
    case /* StmtJstf */5 :
        return "StmtJstf({stmtId=" + diff.stmtId + ", jstfText=" + diff.jstfText + "})";
    case /* StmtCont */6 :
        return "StmtCont({stmtId=" + diff.stmtId + ", cont=" + diff.cont + "})";
    case /* StmtStatus */7 :
        return "StmtStatus({stmtId=" + diff.stmtId + ", proofStatus=" + Belt_Option.getWithDefault(Belt_Option.map(diff.proofStatus, proofStatusToStr), "None") + "})";
    case /* StmtStatusUnset */8 :
        return "StmtStatusUnset({stmtIds=[" + diff.stmtIds.join(", ") + "]})";
    case /* StmtAdd */9 :
        return "StmtAdd({idx=" + String(diff.idx) + ", stmtId=" + diff.stmt.id + "})";
    case /* StmtRemove */10 :
        return "StmtRemove({stmtId=" + diff.stmtId + "})";
    case /* StmtMove */11 :
        return "StmtMove({stmtId=" + diff.stmtId + ", idx=" + String(diff.idx) + "})";
    
  }
}

function diffToStringExtended(diff) {
  return diff.map(diffToStringExtendedSingle).join("\n");
}

function editorHistToStringExtended(ht) {
  var res = [];
  var delim2 = "====================================================================================";
  var curSn = {
    contents: ht.head
  };
  res.push(editorSnapshotToStringExtended(curSn.contents));
  res.push(delim2);
  ht.prev.forEach(function (diff) {
        res.push(diffToStringExtended(diff));
        res.push("------------------------------------------------------------------------------------");
        curSn.contents = diff.reduce(applyDiffSingle, curSn.contents);
        res.push(editorSnapshotToStringExtended(curSn.contents));
        res.push(delim2);
      });
  return res.join("\n");
}

var a_stmts = [
  {
    id: "1",
    label: "label1",
    typ: /* E */0,
    isGoal: false,
    jstfText: "jstfText1",
    cont: "cont1",
    proofStatus: undefined
  },
  {
    id: "2",
    label: "label2",
    typ: /* P */1,
    isGoal: false,
    jstfText: "jstfText2",
    cont: "cont2",
    proofStatus: /* Ready */0
  },
  {
    id: "3",
    label: "label3",
    typ: /* P */1,
    isGoal: true,
    jstfText: "jstfText3",
    cont: "cont3",
    proofStatus: /* Waiting */1
  }
];

var a = {
  descr: "descr",
  varsText: "varsText",
  disjText: "disjText",
  stmts: a_stmts
};

function moveStmtTest(a, stmtId, dIdx) {
  var newStmts = a.stmts.slice();
  var idx = newStmts.findIndex(function (stmt) {
        return stmt.id === stmtId;
      });
  var tmp = Caml_array.get(newStmts, idx);
  Caml_array.set(newStmts, idx, Caml_array.get(newStmts, idx + dIdx | 0));
  Caml_array.set(newStmts, idx + dIdx | 0, tmp);
  return {
          descr: a.descr,
          varsText: a.varsText,
          disjText: a.disjText,
          stmts: newStmts
        };
}

function testApplyDiff(initState, changes, expectedEndState) {
  var diff = findDiff(initState, Curry._1(changes, initState));
  Expln_test.assertEq(diff.length > 0, true);
  var actualEndState = diff.reduce(applyDiffSingle, initState);
  Expln_test.assertEq(actualEndState, expectedEndState);
}

function mm_editor_history__test_findDiff(param) {
  Expln_test.it("finds diffs", (function (param) {
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: a_stmts
                  }), []);
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr-new",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: a_stmts
                  }), [{
                  TAG: /* Descr */0,
                  _0: "descr-new"
                }]);
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr",
                    varsText: "varsText-new",
                    disjText: "disjText",
                    stmts: a_stmts
                  }), [{
                  TAG: /* Vars */1,
                  _0: "varsText-new"
                }]);
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText-new",
                    stmts: a_stmts
                  }), [{
                  TAG: /* Disj */2,
                  _0: "disjText-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "1", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: "label-new",
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: /* StmtLabel */3,
                  stmtId: "1",
                  label: "label-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: /* E */0,
                                  isGoal: stmt.isGoal,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: /* StmtTyp */4,
                  stmtId: "2",
                  typ: /* E */0,
                  isGoal: false
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: true,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: /* StmtTyp */4,
                  stmtId: "2",
                  typ: /* P */1,
                  isGoal: true
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: /* E */0,
                                  isGoal: true,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: /* StmtTyp */4,
                  stmtId: "2",
                  typ: /* E */0,
                  isGoal: true
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: "jstfText-new",
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: /* StmtJstf */5,
                  stmtId: "3",
                  jstfText: "jstfText-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "1", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: stmt.jstfText,
                                  cont: "cont-new",
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: /* StmtCont */6,
                  stmtId: "1",
                  cont: "cont-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: undefined
                                };
                        }))), [{
                  TAG: /* StmtStatus */7,
                  stmtId: "2",
                  proofStatus: undefined
                }]);
          Expln_test.assertEq(findDiff({
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: []
                  }, addStmt({
                        descr: "descr",
                        varsText: "varsText",
                        disjText: "disjText",
                        stmts: []
                      }, 0, {
                        id: "4",
                        label: "label4",
                        typ: /* E */0,
                        isGoal: true,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: /* Ready */0
                      })), [{
                  TAG: /* StmtAdd */9,
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 0, {
                        id: "4",
                        label: "label4",
                        typ: /* E */0,
                        isGoal: true,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: /* Ready */0
                      })), [{
                  TAG: /* StmtAdd */9,
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 1, {
                        id: "4",
                        label: "label4",
                        typ: /* P */1,
                        isGoal: true,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: /* Ready */0
                      })), [{
                  TAG: /* StmtAdd */9,
                  idx: 1,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* P */1,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 2, {
                        id: "4",
                        label: "label4",
                        typ: /* E */0,
                        isGoal: true,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: undefined
                      })), [{
                  TAG: /* StmtAdd */9,
                  idx: 2,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 3, {
                        id: "4",
                        label: "label4",
                        typ: /* P */1,
                        isGoal: true,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: undefined
                      })), [{
                  TAG: /* StmtAdd */9,
                  idx: 3,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* P */1,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(a, "1")), [{
                  TAG: /* StmtRemove */10,
                  stmtId: "1"
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(a, "2")), [{
                  TAG: /* StmtRemove */10,
                  stmtId: "2"
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(a, "3")), [{
                  TAG: /* StmtRemove */10,
                  stmtId: "3"
                }]);
          Expln_test.assertEq(findDiff(addStmt({
                        descr: "descr",
                        varsText: "varsText",
                        disjText: "disjText",
                        stmts: []
                      }, 0, {
                        id: "4",
                        label: "label4",
                        typ: /* E */0,
                        isGoal: true,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: /* Ready */0
                      }), {
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: []
                  }), [{
                  TAG: /* StmtRemove */10,
                  stmtId: "4"
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtTest(a, "1", 1)), [{
                  TAG: /* StmtMove */11,
                  stmtId: "2",
                  idx: 0
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtTest(a, "2", 1)), [{
                  TAG: /* StmtMove */11,
                  stmtId: "3",
                  idx: 1
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(removeStmt(a, "1"), "2")), [
                {
                  TAG: /* StmtRemove */10,
                  stmtId: "1"
                },
                {
                  TAG: /* StmtRemove */10,
                  stmtId: "2"
                }
              ]);
          Expln_test.assertEq(findDiff(a, addStmt(addStmt(a, 0, {
                            id: "4",
                            label: "label4",
                            typ: /* E */0,
                            isGoal: true,
                            jstfText: "jstfText4",
                            cont: "cont4",
                            proofStatus: /* Ready */0
                          }), 2, {
                        id: "5",
                        label: "label5",
                        typ: /* P */1,
                        isGoal: false,
                        jstfText: "jstfText5",
                        cont: "cont5",
                        proofStatus: /* Waiting */1
                      })), [
                {
                  TAG: /* StmtAdd */9,
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }
                },
                {
                  TAG: /* StmtAdd */9,
                  idx: 2,
                  stmt: {
                    id: "5",
                    label: "label5",
                    typ: /* P */1,
                    isGoal: false,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: /* Waiting */1
                  }
                }
              ]);
          Expln_test.assertEq(findDiff(a, moveStmtTest(a, "1", 1)), [{
                  TAG: /* StmtMove */11,
                  stmtId: "2",
                  idx: 0
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtTest(moveStmtTest(a, "1", 1), "1", 1)), [
                {
                  TAG: /* StmtMove */11,
                  stmtId: "2",
                  idx: 0
                },
                {
                  TAG: /* StmtMove */11,
                  stmtId: "3",
                  idx: 1
                }
              ]);
          Expln_test.assertEq(findDiff(a, moveStmtTest(a, "3", -1)), [{
                  TAG: /* StmtMove */11,
                  stmtId: "3",
                  idx: 1
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtTest(moveStmtTest(a, "3", -1), "3", -1)), [{
                  TAG: /* StmtMove */11,
                  stmtId: "3",
                  idx: 0
                }]);
          Expln_test.assertEq(findDiff(updateStmt(updateStmt(updateStmt(a, "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: stmt.label,
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: undefined
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: undefined
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: undefined
                                };
                        })), updateStmt(updateStmt(updateStmt(a, "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: stmt.label,
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: /* Ready */0
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: /* Waiting */1
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: /* JstfIsIncorrect */3
                                };
                        }))), [
                {
                  TAG: /* StmtStatus */7,
                  stmtId: "1",
                  proofStatus: /* Ready */0
                },
                {
                  TAG: /* StmtStatus */7,
                  stmtId: "2",
                  proofStatus: /* Waiting */1
                },
                {
                  TAG: /* StmtStatus */7,
                  stmtId: "3",
                  proofStatus: /* JstfIsIncorrect */3
                }
              ]);
          Expln_test.assertEq(findDiff(a, updateStmt(updateStmt(updateStmt(addStmt({
                                    descr: "descr-new",
                                    varsText: "varsText-new",
                                    disjText: "disjText-new",
                                    stmts: a_stmts
                                  }, 0, {
                                    id: "4",
                                    label: "label4",
                                    typ: /* E */0,
                                    isGoal: true,
                                    jstfText: "jstfText4",
                                    cont: "cont4",
                                    proofStatus: /* Ready */0
                                  }), "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: "ABC",
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: /* NoJstf */2
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: /* E */0,
                                      isGoal: true,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: stmt.proofStatus
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: "BBB",
                                  cont: "TTTTT",
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [
                {
                  TAG: /* StmtAdd */9,
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }
                },
                {
                  TAG: /* StmtLabel */3,
                  stmtId: "1",
                  label: "ABC"
                },
                {
                  TAG: /* StmtStatus */7,
                  stmtId: "1",
                  proofStatus: /* NoJstf */2
                },
                {
                  TAG: /* StmtTyp */4,
                  stmtId: "2",
                  typ: /* E */0,
                  isGoal: true
                },
                {
                  TAG: /* StmtJstf */5,
                  stmtId: "3",
                  jstfText: "BBB"
                },
                {
                  TAG: /* StmtCont */6,
                  stmtId: "3",
                  cont: "TTTTT"
                },
                {
                  TAG: /* Descr */0,
                  _0: "descr-new"
                },
                {
                  TAG: /* Vars */1,
                  _0: "varsText-new"
                },
                {
                  TAG: /* Disj */2,
                  _0: "disjText-new"
                }
              ]);
          Expln_test.assertEq(findDiff(a, addStmt(updateStmt(updateStmt(updateStmt(addStmt({
                                        descr: "descr-new",
                                        varsText: "varsText-new",
                                        disjText: "disjText-new",
                                        stmts: a_stmts
                                      }, 0, {
                                        id: "4",
                                        label: "label4",
                                        typ: /* E */0,
                                        isGoal: true,
                                        jstfText: "jstfText4",
                                        cont: "cont4",
                                        proofStatus: /* Ready */0
                                      }), "1", (function (stmt) {
                                      return {
                                              id: stmt.id,
                                              label: "ABC",
                                              typ: stmt.typ,
                                              isGoal: stmt.isGoal,
                                              jstfText: stmt.jstfText,
                                              cont: stmt.cont,
                                              proofStatus: /* NoJstf */2
                                            };
                                    })), "2", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: stmt.label,
                                          typ: /* E */0,
                                          isGoal: true,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: stmt.proofStatus
                                        };
                                })), "3", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      jstfText: "BBB",
                                      cont: "TTTTT",
                                      proofStatus: stmt.proofStatus
                                    };
                            })), 4, {
                        id: "5",
                        label: "label5",
                        typ: /* E */0,
                        isGoal: true,
                        jstfText: "jstfText5",
                        cont: "cont5",
                        proofStatus: /* Ready */0
                      })), [
                {
                  TAG: /* StmtAdd */9,
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }
                },
                {
                  TAG: /* StmtAdd */9,
                  idx: 4,
                  stmt: {
                    id: "5",
                    label: "label5",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: /* Ready */0
                  }
                },
                {
                  TAG: /* StmtLabel */3,
                  stmtId: "1",
                  label: "ABC"
                },
                {
                  TAG: /* StmtStatus */7,
                  stmtId: "1",
                  proofStatus: /* NoJstf */2
                },
                {
                  TAG: /* StmtTyp */4,
                  stmtId: "2",
                  typ: /* E */0,
                  isGoal: true
                },
                {
                  TAG: /* StmtJstf */5,
                  stmtId: "3",
                  jstfText: "BBB"
                },
                {
                  TAG: /* StmtCont */6,
                  stmtId: "3",
                  cont: "TTTTT"
                },
                {
                  TAG: /* Descr */0,
                  _0: "descr-new"
                },
                {
                  TAG: /* Vars */1,
                  _0: "varsText-new"
                },
                {
                  TAG: /* Disj */2,
                  _0: "disjText-new"
                }
              ]);
        }));
}

function mm_editor_history__test_applyDiff(param) {
  Expln_test.it("applies diffs", (function (param) {
          testApplyDiff(a, (function (sn) {
                  return {
                          descr: "descr-new",
                          varsText: sn.varsText,
                          disjText: sn.disjText,
                          stmts: sn.stmts
                        };
                }), {
                descr: "descr-new",
                varsText: "varsText",
                disjText: "disjText",
                stmts: a_stmts
              });
          testApplyDiff(a, (function (sn) {
                  return {
                          descr: sn.descr,
                          varsText: "varsText-new",
                          disjText: sn.disjText,
                          stmts: sn.stmts
                        };
                }), {
                descr: "descr",
                varsText: "varsText-new",
                disjText: "disjText",
                stmts: a_stmts
              });
          testApplyDiff(a, (function (sn) {
                  return {
                          descr: sn.descr,
                          varsText: sn.varsText,
                          disjText: "disjText-new",
                          stmts: sn.stmts
                        };
                }), {
                descr: "descr",
                varsText: "varsText",
                disjText: "disjText-new",
                stmts: a_stmts
              });
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "1", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: "label-new",
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "1", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: "label-new",
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: /* E */0,
                                        isGoal: stmt.isGoal,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: /* E */0,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: true,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: true,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: /* E */0,
                                        isGoal: true,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: /* E */0,
                              isGoal: true,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "3", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        jstfText: "jstfText-new",
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "3", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: "jstfText-new",
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "1", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        jstfText: stmt.jstfText,
                                        cont: "cont-new",
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "1", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: "cont-new",
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: undefined
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: undefined
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 0, {
                              id: "4",
                              label: "label4",
                              typ: /* E */0,
                              isGoal: true,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: /* Ready */0
                            });
                }), addStmt(a, 0, {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 1, {
                              id: "4",
                              label: "label4",
                              typ: /* P */1,
                              isGoal: true,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: /* Ready */0
                            });
                }), addStmt(a, 1, {
                    id: "4",
                    label: "label4",
                    typ: /* P */1,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: /* Ready */0
                  }));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 2, {
                              id: "4",
                              label: "label4",
                              typ: /* E */0,
                              isGoal: true,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: undefined
                            });
                }), addStmt(a, 2, {
                    id: "4",
                    label: "label4",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 3, {
                              id: "4",
                              label: "label4",
                              typ: /* P */1,
                              isGoal: true,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: undefined
                            });
                }), addStmt(a, 3, {
                    id: "4",
                    label: "label4",
                    typ: /* P */1,
                    isGoal: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }));
          testApplyDiff(a, (function (__x) {
                  return removeStmt(__x, "1");
                }), removeStmt(a, "1"));
          testApplyDiff(a, (function (__x) {
                  return removeStmt(__x, "2");
                }), removeStmt(a, "2"));
          testApplyDiff(a, (function (__x) {
                  return removeStmt(__x, "3");
                }), removeStmt(a, "3"));
          testApplyDiff(a, (function (__x) {
                  return moveStmtTest(__x, "1", 1);
                }), moveStmtTest(a, "1", 1));
          testApplyDiff(a, (function (__x) {
                  return moveStmtTest(__x, "2", 1);
                }), moveStmtTest(a, "2", 1));
          testApplyDiff(a, (function (sn) {
                  return removeStmt(removeStmt(sn, "1"), "2");
                }), removeStmt(removeStmt(a, "1"), "2"));
          testApplyDiff(a, (function (sn) {
                  return addStmt(addStmt(sn, 0, {
                                  id: "4",
                                  label: "label4",
                                  typ: /* E */0,
                                  isGoal: true,
                                  jstfText: "jstfText4",
                                  cont: "cont4",
                                  proofStatus: /* Ready */0
                                }), 2, {
                              id: "5",
                              label: "label5",
                              typ: /* P */1,
                              isGoal: false,
                              jstfText: "jstfText5",
                              cont: "cont5",
                              proofStatus: /* Waiting */1
                            });
                }), addStmt(addStmt(a, 0, {
                        id: "4",
                        label: "label4",
                        typ: /* E */0,
                        isGoal: true,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: /* Ready */0
                      }), 2, {
                    id: "5",
                    label: "label5",
                    typ: /* P */1,
                    isGoal: false,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: /* Waiting */1
                  }));
          testApplyDiff(a, (function (sn) {
                  return moveStmtTest(moveStmtTest(sn, "1", 1), "1", 1);
                }), moveStmtTest(moveStmtTest(a, "1", 1), "1", 1));
          testApplyDiff(a, (function (sn) {
                  return updateStmt(updateStmt(updateStmt(sn, "1", (function (stmt) {
                                        return {
                                                id: stmt.id,
                                                label: stmt.label,
                                                typ: stmt.typ,
                                                isGoal: stmt.isGoal,
                                                jstfText: stmt.jstfText,
                                                cont: stmt.cont,
                                                proofStatus: undefined
                                              };
                                      })), "2", (function (stmt) {
                                    return {
                                            id: stmt.id,
                                            label: stmt.label,
                                            typ: stmt.typ,
                                            isGoal: stmt.isGoal,
                                            jstfText: stmt.jstfText,
                                            cont: stmt.cont,
                                            proofStatus: undefined
                                          };
                                  })), "3", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: undefined
                                      };
                              }));
                }), updateStmt(updateStmt(updateStmt(a, "1", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: undefined
                                    };
                            })), "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: undefined
                                };
                        })), "3", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: undefined
                            };
                    })));
          testApplyDiff(a, (function (sn) {
                  return updateStmt(updateStmt(updateStmt(addStmt({
                                          descr: "descr-new",
                                          varsText: "varsText-new",
                                          disjText: "disjText-new",
                                          stmts: sn.stmts
                                        }, 0, {
                                          id: "4",
                                          label: "label4",
                                          typ: /* E */0,
                                          isGoal: true,
                                          jstfText: "jstfText4",
                                          cont: "cont4",
                                          proofStatus: /* Ready */0
                                        }), "1", (function (stmt) {
                                        return {
                                                id: stmt.id,
                                                label: "ABC",
                                                typ: stmt.typ,
                                                isGoal: stmt.isGoal,
                                                jstfText: stmt.jstfText,
                                                cont: stmt.cont,
                                                proofStatus: /* NoJstf */2
                                              };
                                      })), "2", (function (stmt) {
                                    return {
                                            id: stmt.id,
                                            label: stmt.label,
                                            typ: /* E */0,
                                            isGoal: true,
                                            jstfText: stmt.jstfText,
                                            cont: stmt.cont,
                                            proofStatus: stmt.proofStatus
                                          };
                                  })), "3", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        jstfText: "BBB",
                                        cont: "TTTTT",
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(updateStmt(updateStmt(addStmt({
                                descr: "descr-new",
                                varsText: "varsText-new",
                                disjText: "disjText-new",
                                stmts: a_stmts
                              }, 0, {
                                id: "4",
                                label: "label4",
                                typ: /* E */0,
                                isGoal: true,
                                jstfText: "jstfText4",
                                cont: "cont4",
                                proofStatus: /* Ready */0
                              }), "1", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: "ABC",
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: /* NoJstf */2
                                    };
                            })), "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: /* E */0,
                                  isGoal: true,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        })), "3", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              jstfText: "BBB",
                              cont: "TTTTT",
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (param) {
                  return addStmt(updateStmt(updateStmt(updateStmt(addStmt({
                                              descr: "descr-new",
                                              varsText: "varsText-new",
                                              disjText: "disjText-new",
                                              stmts: a_stmts
                                            }, 0, {
                                              id: "4",
                                              label: "label4",
                                              typ: /* E */0,
                                              isGoal: true,
                                              jstfText: "jstfText4",
                                              cont: "cont4",
                                              proofStatus: /* Ready */0
                                            }), "1", (function (stmt) {
                                            return {
                                                    id: stmt.id,
                                                    label: "ABC",
                                                    typ: stmt.typ,
                                                    isGoal: stmt.isGoal,
                                                    jstfText: stmt.jstfText,
                                                    cont: stmt.cont,
                                                    proofStatus: /* NoJstf */2
                                                  };
                                          })), "2", (function (stmt) {
                                        return {
                                                id: stmt.id,
                                                label: stmt.label,
                                                typ: /* E */0,
                                                isGoal: true,
                                                jstfText: stmt.jstfText,
                                                cont: stmt.cont,
                                                proofStatus: stmt.proofStatus
                                              };
                                      })), "3", (function (stmt) {
                                    return {
                                            id: stmt.id,
                                            label: stmt.label,
                                            typ: stmt.typ,
                                            isGoal: stmt.isGoal,
                                            jstfText: "BBB",
                                            cont: "TTTTT",
                                            proofStatus: stmt.proofStatus
                                          };
                                  })), 4, {
                              id: "5",
                              label: "label5",
                              typ: /* E */0,
                              isGoal: true,
                              jstfText: "jstfText5",
                              cont: "cont5",
                              proofStatus: /* Ready */0
                            });
                }), addStmt(updateStmt(updateStmt(updateStmt(addStmt({
                                    descr: "descr-new",
                                    varsText: "varsText-new",
                                    disjText: "disjText-new",
                                    stmts: a_stmts
                                  }, 0, {
                                    id: "4",
                                    label: "label4",
                                    typ: /* E */0,
                                    isGoal: true,
                                    jstfText: "jstfText4",
                                    cont: "cont4",
                                    proofStatus: /* Ready */0
                                  }), "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: "ABC",
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: /* NoJstf */2
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: /* E */0,
                                      isGoal: true,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: stmt.proofStatus
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  jstfText: "BBB",
                                  cont: "TTTTT",
                                  proofStatus: stmt.proofStatus
                                };
                        })), 4, {
                    id: "5",
                    label: "label5",
                    typ: /* E */0,
                    isGoal: true,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: /* Ready */0
                  }));
        }));
}

exports.editorHistMake = editorHistMake;
exports.editorHistAddSnapshot = editorHistAddSnapshot;
exports.editorHistSetMaxLength = editorHistSetMaxLength;
exports.editorHistIsEmpty = editorHistIsEmpty;
exports.editorHistLength = editorHistLength;
exports.editorHistGetSnapshotPreview = editorHistGetSnapshotPreview;
exports.restoreEditorStateFromSnapshot = restoreEditorStateFromSnapshot;
exports.editorHistToString = editorHistToString;
exports.editorHistFromString = editorHistFromString;
exports.editorHistToStringExtended = editorHistToStringExtended;
exports.mm_editor_history__test_findDiff = mm_editor_history__test_findDiff;
exports.mm_editor_history__test_applyDiff = mm_editor_history__test_applyDiff;
/* MM_wrk_editor Not a pure module */
